import { Component } from '@angular/core';

@Component({
  selector: 'privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['../terms-and-privacy-policy-styles.scss'],
  host: { class: 'ht-privacy-policy' }
})
export class PrivacyPolicyComponent {}
